/** Gets a random number between 2 numbers */
export const randomIntFromInterval = (min: number, max: number): number =>
  Math.floor(Math.random() * (max - min + 1) + min)

export const shuffleList = (array: any[]) => {
  let currentIndex = array.length,
    randomIndex

  // While there remain elements to shuffle.
  while (currentIndex != 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex--
    ;[array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]]
  }

  return array
}

export const selectRandomItemWeightedByOrder = (array: any[], field: string) => {
  const descSortedList = array.sort((a, b) => (a[field] > b[field] ? -1 : 1))

  // higher the weighting the less randomness
  const weightOrderAgainstRandomnessFactor = 1
  if (weightOrderAgainstRandomnessFactor >= 10) return descSortedList[descSortedList.length - 1]

  const nItemsInArr = array.length
  const indices = Array.from(new Array(nItemsInArr).keys())
  let indicesForSelection: number[] = []
  indices.forEach((index, i) => {
    const nCopiesToGenerate = Math.round(
      Math.max(1, weightOrderAgainstRandomnessFactor) * index
    );
    const generatedIndices = Array(Math.floor(nCopiesToGenerate) + 1).fill(index)
    indicesForSelection = [...indicesForSelection, ...generatedIndices]
  })

  const shuffledIndices = shuffleList(indicesForSelection)
  return array[shuffledIndices[0]]
}
